import axios from "axios";
import Config from "src/config";

const BASE = Config.dev ? Config.url_dev : Config.urlBackend;

export const getMktOverview = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/insights/overview${querys || ''}`
    });
};

export const getMktInstagramInsights = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/insights/instagram${querys || ''}`
    });
};

export const getMktFacebookInsights = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/insights/facebook${querys || ''}`
    });
};

export const getMktGoogleAdsInsights = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/insights/google-ads${querys || ''}`
    });
};

export const getMktDemographics = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/insights/demographics${querys || ''}`
    });
};
